import React from "react";
import PropTypes from "prop-types";
import { Empty } from "antd";
import FileSnapshot from "./file-snapshot";

class DocumentChecklistGrid extends React.Component {
    render() {
        const { groups, checklist, documents } = this.props;
        if (groups && groups.size) {
            return (
                <div
                    style={{
                        height: "600px",
                        overflow: "scroll"
                    }}
                >
                    {groups.map(_ => (
                        <div key={_.id} className={"d-flex flex-wrap"}>
                            <div
                                style={{
                                    flexBasis: "100%"
                                }}
                            >
                                <h2>{_.label}</h2>
                            </div>
                            {checklist ? (
                                checklist.map(document => (
                                    <FileSnapshot
                                        key={document.id}
                                        document={document}
                                        record={documents.find(
                                            doc =>
                                                doc.get("data").document ===
                                                    document.id &&
                                                (!_.id ||
                                                    doc.get("data")
                                                        .associate === _.id ||
                                                    doc.get("data")
                                                        .company_bank === _.id)
                                        )}
                                        {...{
                                            associate: null,
                                            bank: null,
                                            [_.type]: _.id
                                        }}
                                    />
                                ))
                            ) : (
                                <Empty />
                            )}
                        </div>
                    ))}
                </div>
            );
        }
        return (
            <div
                className={"d-flex flex-wrap"}
                style={{
                    minHeight: "600px"
                }}
            >
                {checklist ? (
                    checklist.map(document => (
                        <FileSnapshot
                            associate={null}
                            bank={null}
                            key={document.id}
                            document={document}
                            record={documents.find(
                                _ => _.get("data").document === document.id
                            )}
                        />
                    ))
                ) : (
                    <Empty />
                )}
            </div>
        );
    }
}

DocumentChecklistGrid.propTypes = {
    associate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    bank: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    checklist: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    groups: PropTypes.object,
    documents: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

export default DocumentChecklistGrid;
